import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { checkAuth } from "../libs/auth";
import { setUser, setUserToken } from "../libs/user";
import { getUserProfile } from "../services/auth";

const Protected = ({ children }) => {
  const [searchParams] = useSearchParams();
  const extToken = searchParams.get("token");
  if (extToken) {
    setUserToken(extToken);
    getUserProfile(extToken)
      .then((response) => {
        setUser(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const isLoggedIn = checkAuth();

  if (!isLoggedIn) {
    return <Navigate to="/login?type=mobile" replace />;
  }
  return children;
};

export default Protected;
